import { FC } from 'react';
import { Box, LinearProgress, LinearProgressProps, styled, Typography } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;
`;

export const LinearProgressWithLabel: FC<LinearProgressProps> = ({ value, className, ...rest }) => {
  return (
    <Container display='flex' alignItems='center' className={className}>
      <Box width='100%' mr={1}>
        <LinearProgress variant={value ? 'determinate' : 'indeterminate'} value={value} {...rest} />
      </Box>
      {value && (
        <Box minWidth={35}>
          <Typography variant='body2' color='textSecondary'>
            {`${Math.round(value)}%`}
          </Typography>
        </Box>
      )}
    </Container>
  );
};
